module.exports = __webpack_public_path__ + "static/media/kneecap-up-3.f3b02ad9.png";